const featureToggles = {
  // Allow-list of user IDs who see gated features.
  featureFlagOverrideUserIds: [2, 341236],
  // PAYG credit purchase on pricing page (TP-187). When true and TEST_START_DATE has passed,
  // users are split A/B: even user IDs = control (PAYG hidden), odd = treatment (PAYG visible).
  paygCreditsPricingPage: false,
  // Require verified phone before a job poster messages applicants (TP-451).
  // Keep false until rolled out with the API toggle.
  requireJobPosterPhoneVerification: false,
};

export default featureToggles;
